module.exports = __webpack_public_path__ + "img/background.f62da660.jpg";